import { isCurrentView, togglePassword } from "../../../shared/utils/view-util";

// Login
document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.sessions.new")) {
    return;
  }
  const userPassword = document.getElementById("user_password");
  const userPasswordWrapper = document.getElementById("password_wrapper");
  togglePassword(userPassword, userPasswordWrapper);
});

// Reset password
document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.passwords.edit")) {
    return;
  }
  const userPassword = document.getElementById("user_password");
  const userPasswordWrapper = document.getElementById("password_wrapper");
  const userPasswordConfirmation = document.getElementById(
    "user_password_confirmation",
  );
  const passwordConfirmationWrapper = document.getElementById(
    "password_confirmation_wrapper",
  );
  togglePassword(userPassword, userPasswordWrapper);
  togglePassword(userPasswordConfirmation, passwordConfirmationWrapper);
});

// Update password
document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.passwords.update")) {
    return;
  }
  const userPassword = document.getElementById("user_password");
  const userPasswordWrapper = document.getElementById("password_wrapper");
  const userPasswordConfirmation = document.getElementById(
    "user_password_confirmation",
  );
  const passwordConfirmationWrapper = document.getElementById(
    "password_confirmation_wrapper",
  );
  togglePassword(userPassword, userPasswordWrapper);
  togglePassword(userPasswordConfirmation, passwordConfirmationWrapper);
});

// POS invite set password
document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.pos_invite.pos_invite_set_password")) {
    return;
  }
  const userPassword = document.getElementById("user_password");
  const userPasswordWrapper = document.getElementById("password_wrapper");
  const userPasswordConfirmation = document.getElementById(
    "user_password_confirmation",
  );
  const passwordConfirmationWrapper = document.getElementById(
    "password_confirmation_wrapper",
  );
  togglePassword(userPassword, userPasswordWrapper);
  togglePassword(userPasswordConfirmation, passwordConfirmationWrapper);
});
